export default __webpack_public_path__ + "static/media/nft-12.9699ef7c.png";